document.addEventListener('DOMContentLoaded', function() {
  function updateUpsellDisplay() {
    const isMobile = window.innerWidth <= 749;
    const allUpsellProducts = document.querySelectorAll('.ec-cart-upsell__product[data-product-id]');
    
    allUpsellProducts.forEach(function(product) {
      const productId = product.getAttribute('data-product-id');
      const isDesktop = product.classList.contains('ec-cart-upsell__product--desktop');
      const isMobileVersion = product.classList.contains('ec-cart-upsell__product--mobile');
      
      if (isMobile) {
        if (isDesktop) {
          product.style.display = 'none';
        } else if (isMobileVersion) {
          const desktopVersion = document.querySelector('.ec-cart-upsell__product--desktop[data-product-id="' + productId + '"]');
          if (desktopVersion && desktopVersion.style.display !== 'none') {
            product.style.display = 'flex';
          } else if (!desktopVersion || desktopVersion.style.display === 'none') {
            product.style.display = 'flex';
          }
        }
      } else {
        if (isMobileVersion) {
          product.style.display = 'none';
        } else if (isDesktop) {
          product.style.display = 'flex';
        }
      }
    });
  }
  
  updateUpsellDisplay();
  window.addEventListener('resize', updateUpsellDisplay);
  
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
        updateUpsellDisplay();
      }
    });
  });
  
  const upsellContainer = document.querySelector('.ec-cart-upsell__products-container');
  if (upsellContainer) {
    observer.observe(upsellContainer, {
      attributes: true,
      attributeFilter: ['style'],
      subtree: true
    });
  }
  
  const upsellButtons = document.querySelectorAll('.ec-cart-upsell__product-button');
  
  upsellButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      if (this.disabled) return;
      
      const variantId = this.getAttribute('data-variant-id');
      const productId = this.getAttribute('data-product-id');
      
      if (!variantId) return;
      
      const originalText = this.textContent;
      this.disabled = true;
      this.textContent = 'Adicionando...';
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        if (data.status) {
          throw new Error(data.description || 'Erro ao adicionar produto');
        }
        
        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'ec-cart-upsell',
            productVariantId: variantId,
            cartData: data
          });
        }
        
        window.location.reload();
      })
      .catch(function(error) {
        console.error('Erro ao adicionar produto:', error);
        button.disabled = false;
        button.textContent = originalText;
        alert('Erro ao adicionar produto ao carrinho. Tente novamente.');
      });
    });
  });
});
